/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../theme';
const TopLevelBlock = React.forwardRef((props, ref) => {
    const { topDropTarget, bottomDropTarget, ...restProps } = props;
    const theme = useTheme();
    return (jsx("div", Object.assign({}, restProps, { ref: ref, css: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            boxSizing: 'content-box',
            borderColor: theme.colors.dropTarget.marker,
            borderTop: topDropTarget
                ? `1px solid ${theme.colors.dropTarget.marker}`
                : undefined,
            borderBottom: bottomDropTarget
                ? `1px solid ${theme.colors.dropTarget.marker}`
                : undefined,
        } })));
});
TopLevelBlock.displayName = 'TopLevelBlock';
export default React.memo(TopLevelBlock);
//# sourceMappingURL=TopLevelBlock.js.map